import * as React from 'react';

import { cn } from '../../lib/utils';

export interface LoginCardProps {
  /** Content to render inside the card */
  children: React.ReactNode;
  /** Additional CSS classes for the outer wrapper */
  className?: string;
  /** Width of the card (default: 482px) */
  width?: number;
  /** Height of the card (default: 480px) */
  height?: number;
}

/**
 * LoginCard Molecule
 *
 * The centered card container for login forms with:
 * - Solid white background
 * - 8px border radius
 * - 40px padding
 * - Min dimensions: 402x400px
 *
 * Note: The semi-transparent wrapper is provided by AuthLayout,
 * not by this component.
 *
 * @example
 * ```tsx
 * <LoginCard>
 *   <LoginForm />
 * </LoginCard>
 * ```
 */
export const LoginCard = React.forwardRef<HTMLDivElement, LoginCardProps>(
  ({ children, className, width = 402, height = 400 }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-dawn-white rounded-lg p-10 flex flex-col gap-10 items-center relative',
          className
        )}
        style={{ minWidth: `${width}px`, minHeight: `${height}px` }}
      >
        {children}
      </div>
    );
  }
);

LoginCard.displayName = 'LoginCard';

export default LoginCard;
